import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout'


Vue.use(VueRouter)

  const routes = [
	{
		path: '/',
		name: 'Layout',
		component: Layout,
		redirect: '/home',
		children: [
			{
				path: '/home',
				name: 'Home',
				meta: {
					title: '數據主頁 | NoWait System'
				},
				// route level code-splitting
				// this generates a separate chunk (about.[hash].js) for this route
				// which is lazy-loaded when the route is visited.
				component: () => import(/* webpackChunkName: "login" */ '../views/Home')
			},
			{
				path: '/corporateInformation',
				name: 'CorporateInformation',
				meta: {
					title: '修改資料 | NoWait System'
				},
				// route level code-splitting
				// this generates a separate chunk (about.[hash].js) for this route
				// which is lazy-loaded when the route is visited.
				component: () => import(/* webpackChunkName: "corporateInformation" */ '../views/corporateInformation/index')
			},
			{
				path: '/changePassword',
				name: 'ChangePassword',
				meta: {
					title: '修改密碼 | NoWait System'
				},
				// route level code-splitting
				// this generates a separate chunk (about.[hash].js) for this route
				// which is lazy-loaded when the route is visited.
				component: () => import(/* webpackChunkName: "ChangePassword" */ '../views/corporateInformation/ChangePassword')
			},
			{
				path: '/backmsg',
				name: 'backmsg',
				meta: {
					title: '顧客信息 | NoWait System'
				},
				// route level code-splitting
				// this generates a separate chunk (about.[hash].js) for this route
				// which is lazy-loaded when the route is visited.
				component: () => import(/* webpackChunkName: "ChangePassword" */ '../views/message/backmsg')
			},
			{
				path: '/history',
				name: 'history',
				meta: {
					title: '顧客信息 | NoWait System'
				},
				// route level code-splitting
				// this generates a separate chunk (about.[hash].js) for this route
				// which is lazy-loaded when the route is visited.
				component: () => import(/* webpackChunkName: "ChangePassword" */ '../views/message/history')
			},
            {
				path: '/history2',
				name: 'history2',
				meta: {
					title: '顧客信息2 | NoWait System'
				},
				// route level code-splitting
				// this generates a separate chunk (about.[hash].js) for this route
				// which is lazy-loaded when the route is visited.
				component: () => import(/* webpackChunkName: "ChangePassword" */ '../views/message/history5')
			},
			{
				path: '/packagePurchase',
				name: 'PackagePurchase',
				meta: {
					title: '增值 | NoWait System'
				},
				// route level code-splitting
				// this generates a separate chunk (about.[hash].js) for this route
				// which is lazy-loaded when the route is visited.
				component: () => import(/* webpackChunkName: "PackagePurchase" */ '../views/corporateInformation/PackagePurchase')
			},
			{
				path: '/template',
				name: 'Template',
				// route level code-splitting
				// this generates a separate chunk (about.[hash].js) for this route
				// which is lazy-loaded when the route is visited.
				component: () => import(/* webpackChunkName: "PackagePurchase" */ '../views/template/index')
			},
			{
				path: '/kehu',
				name: 'kehu',
				meta: {
					title: '會員列表 | NoWait System'
				},
				// route level code-splitting
				// this generates a separate chunk (about.[hash].js) for this route
				// which is lazy-loaded when the route is visited.
				component: () => import(/* webpackChunkName: "PackagePurchase" */ '../views/kehu/index')
			},
			{
				path: '/rili',
				name: 'rili',
				// route level code-splitting
				// this generates a separate chunk (about.[hash].js) for this route
				// which is lazy-loaded when the route is visited.
				component: () => import(/* webpackChunkName: "PackagePurchase" */ '../views/kehu/rl')
			},
			{
				path: '/autoTemplate',
				name: 'Template',
				meta: {
					title: '自動回覆設定 | NoWait System'
				},
				// route level code-splitting
				// this generates a separate chunk (about.[hash].js) for this route
				// which is lazy-loaded when the route is visited.
				component: () => import(/* webpackChunkName: "PackagePurchase" */ '../views/template/autotemplate')
			},
			{
				path: '/metaTemplate',
				name: 'Template',
				meta: {
					title: 'Meta範本列表 | NoWait System'
				},
				component: () => import(/* webpackChunkName: "PackagePurchase" */ '../views/template/metatemplate')
			},
			{
				path: '/guanfang',
				name: 'gfTemplate',
				// route level code-splitting
				// this generates a separate chunk (about.[hash].js) for this route
				// which is lazy-loaded when the route is visited.
				component: () => import(/* webpackChunkName: "PackagePurchase" */ '../views/template/guanfang')
			},
			{
				path: '/huodong',
				name: 'Huodong',
				meta: {
					title: '活動記錄 | NoWait System'
				},
				// route level code-splitting
				// this generates a separate chunk (about.[hash].js) for this route
				// which is lazy-loaded when the route is visited.
				component: () => import(/* webpackChunkName: "PackagePurchase" */ '../views/template/huodong')
			},
            {
				path: '/huodong2',
				name: 'Huodong',
				meta: {
					title: '活動記錄 | NoWait System'
				},
				// route level code-splitting
				// this generates a separate chunk (about.[hash].js) for this route
				// which is lazy-loaded when the route is visited.
				component: () => import(/* webpackChunkName: "PackagePurchase" */ '../views/template/huodongcounttoken')
			},
			{
				path: '/tuijian',
				name: 'tuijian',
				// route level code-splitting
				// this generates a separate chunk (about.[hash].js) for this route
				// which is lazy-loaded when the route is visited.
				component: () => import(/* webpackChunkName: "PackagePurchase" */ '../views/tuijian/index')
			},
			{
				path: '/tongyong2',
				name: 'Template',
				meta: {
					title: '群發訊息記錄 | NoWait System'
				},
				// route level code-splitting
				// this generates a separate chunk (about.[hash].js) for this route
				// which is lazy-loaded when the route is visited.
				component: () => import(/* webpackChunkName: "PackagePurchase" */ '../views/tongyong2/index')
			},
			{
				path: '/product',
				name: 'Product',
				meta: {
					title: '商品列表 | NoWait System'
				},
				component: () => import(/* webpackChunkName: "PackagePurchase" */ '../views/tongyong/product')
			},
			{
				path: '/order',
				name: 'Order',
				meta: {
					title: '訂單記錄 | NoWait System'
				},
				component: () => import(/* webpackChunkName: "PackagePurchase" */ '../views/tongyong/order')
			},
			{
				path: '/payment',
				name: 'Payment',
				meta: {
					title: '收款記錄 | NoWait System'
				},
				component: () => import(/* webpackChunkName: "PackagePurchase" */ '../views/tongyong/payment')
			},
			{
				path: '/fpshistory',
				name: 'FPSHistory',
				meta: {
					title: 'FPS結算記錄 | NoWait System'
				},
				component: () => import(/* webpackChunkName: "PackagePurchase" */ '../views/tongyong/fpshistory')
			},
			{
				path: '/fpshistorysim',
				name: 'FPSHistorySIM',
				meta: {
					title: 'FPS結算記錄SIM | NoWait System'
				},
				component: () => import(/* webpackChunkName: "PackagePurchase" */ '../views/tongyong/fpshistory_sim')
			},
			{
				path: '/tongyong/:sjk',
				name: 'Template',
				// route level code-splitting
				// this generates a separate chunk (about.[hash].js) for this route
				// which is lazy-loaded when the route is visited.
				component: () => import(/* webpackChunkName: "PackagePurchase" */ '../views/tongyong/index')
			},
			{
				path: '/renwulist',
				name: 'Renwulist',
				meta: {
					title: '群發訊息列表 | NoWait System'
				},
				// route level code-splitting
				// this generates a separate chunk (about.[hash].js) for this route
				// which is lazy-loaded when the route is visited.
				component: () => import(/* webpackChunkName: "PackagePurchase" */ '../views/renwulist/index')
			},
			{
				path: '/pendingList',
				name: 'PendingList',
				meta: {
					title: '會員群組 | NoWait System'
				},
				// route level code-splitting
				// this generates a separate chunk (about.[hash].js) for this route
				// which is lazy-loaded when the route is visited.
				component: () => import(/* webpackChunkName: "PackagePurchase" */ '../views/pendingList/index')
			},		
			{
				path: '/userList',
				name: 'UserList',
				meta: {
					title: '會員列表 | NoWait System'
				},
				// route level code-splitting
				// this generates a separate chunk (about.[hash].js) for this route
				// which is lazy-loaded when the route is visited.
				component: () => import(/* webpackChunkName: "PackagePurchase" */ '../views/kehu/UserList')
			},
			{
				path: '/waitset/:pageid',
				name: 'waitset',
				// route level code-splitting
				// this generates a separate chunk (about.[hash].js) for this route
				// which is lazy-loaded when the route is visited.
				component: () => import(/* webpackChunkName: "PackagePurchase" */ '../views/wait/waitset')
			},		
			{
				path: '/messenger',
				name: 'messenger',
				// route level code-splitting
				// this generates a separate chunk (about.[hash].js) for this route
				// which is lazy-loaded when the route is visited.
				component: () => import(/* webpackChunkName: "PackagePurchase" */ '../views/wait/messenger')
			},
			{
				path: '/store',
				name: 'store',
                meta: {
					title: '分店設定 | NoWait System'
				},
				// route level code-splitting
				// this generates a separate chunk (about.[hash].js) for this route
				// which is lazy-loaded when the route is visited.
				component: () => import(/* webpackChunkName: "PackagePurchase" */ '../views/corporateInformation/Store')
			},
			{
				path: '/userSettings',
				name: 'UserProfileSettings',
				meta: {
					title: '用戶資料設定 | NoWait System'
				},
				component: () => import(/* webpackChunkName: "UserProfileSettings" */ '../views/settings/UserProfileSettings')
			},
            {
				path: '/topup',
				name: 'topup',
                meta: {
					title: '儲值 | NoWait System'
				},
				// route level code-splitting
				// this generates a separate chunk (about.[hash].js) for this route
				// which is lazy-loaded when the route is visited.
				component: () => import(/* webpackChunkName: "PackagePurchase" */ '../views/corporateInformation/Topup')
			},
            {
				path: '/topupplan',
				name: 'topupplan',
                meta: {
					title: '儲值計劃 | NoWait System'
				},
				// route level code-splitting
				// this generates a separate chunk (about.[hash].js) for this route
				// which is lazy-loaded when the route is visited.
				component: () => import(/* webpackChunkName: "PackagePurchase" */ '../views/corporateInformation/Topupplan')
			},
            {
				path: '/topuprecord',
				name: 'topuprecord',
                meta: {
					title: '儲值記錄 | NoWait System'
				},
				// route level code-splitting
				// this generates a separate chunk (about.[hash].js) for this route
				// which is lazy-loaded when the route is visited.
				component: () => import(/* webpackChunkName: "PackagePurchase" */ '../views/corporateInformation/Topuprecord')
			},
            {
				path: '/bookingrecord',
				name: 'bookingrecord',
                meta: {
					title: '預約記錄 | NoWait System'
				},
				// route level code-splitting
				// this generates a separate chunk (about.[hash].js) for this route
				// which is lazy-loaded when the route is visited.
				component: () => import(/* webpackChunkName: "PackagePurchase" */ '../views/booking/bookingrecord')
			},
			{
				path: '/chart',
				name: 'chart',
				// route level code-splitting
				// this generates a separate chunk (about.[hash].js) for this route
				// which is lazy-loaded when the route is visited.
				component: () => import(/* webpackChunkName: "PackagePurchase" */ '../views/chart/chart')
			},
			{
				path: '/jiaohao',
				name: 'jiaohao',
				// route level code-splitting
				// this generates a separate chunk (about.[hash].js) for this route
				// which is lazy-loaded when the route is visited.
				component: () => import(/* webpackChunkName: "PackagePurchase" */ '../views/wait/jiaohao')
			},					
			{
				path: '/wlogin',
				name: 'loginwhatsapp',
				// route level code-splitting
				// this generates a separate chunk (about.[hash].js) for this route
				// which is lazy-loaded when the route is visited.
				component: () => import(/* webpackChunkName: "PackagePurchase" */ '../views/wait/wlogin')
			},			
			{
				path: '/chart',
				name: 'chart',
				// route level code-splitting
				// this generates a separate chunk (about.[hash].js) for this route
				// which is lazy-loaded when the route is visited.
				component: () => import(/* webpackChunkName: "PackagePurchase" */ '../views/chart/chart')
			},
			{
				path: '/financialManagement',
				name: 'rechargeRecord',
				// route level code-splitting
				// this generates a separate chunk (about.[hash].js) for this route
				// which is lazy-loaded when the route is visited.
				component: () => import(/* webpackChunkName: "PackagePurchase" */ '../views/financialManagement/rechargeRecord')
			},
			{
				path: '/invoiceRecord',
				name: 'invoiceRecord',
				// route level code-splitting
				// this generates a separate chunk (about.[hash].js) for this route
				// which is lazy-loaded when the route is visited.
				component: () => import(/* webpackChunkName: "PackagePurchase" */ '../views/financialManagement/invoiceRecord')
			},
		]
	},
	{
		path: '/login',
		name: 'Login',
		meta: {
			title: '登入 | NoWait System'
		},
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "login" */ '../views/login')
	}
]

const router = new VueRouter({
  routes,
})

router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next();
})

export default router
